import { ShiftsLeaveFragment } from 'generated/resources/graphql'
import { groupBy, uniq } from 'lodash'
import { computed, makeObservable } from 'mobx'
import type moment from 'moment'

import Leave, { LeavePayload } from 'modules/shift_management/store/internal/models/Leave'

class Leaves {
  leaves: Leave[]

  constructor(leaves: Leave[]) {
    this.leaves = leaves

    makeObservable(this, {
      leavesLength: computed,
      leaveTypes: computed,
      _groupByType: computed,
    })
  }

  /**
   * Transforms an array of objects from a request into an array of Leave
   * objects
   */
  /**
   * @deprecated Before using this method, consider using the `buildFromGraphQL` hook since
   * we are trying to move away from using mobx-rest and use GraphQL instead.
   */
  static buildFromProps(leaves: LeavePayload[]): Leaves {
    const leaveObjects = leaves.map((leave) => new Leave(leave))

    return new Leaves(leaveObjects)
  }

  static buildFromGraphQL(leaves: ShiftsLeaveFragment[]): Leaves {
    const leaveObjects = leaves.map((leave) => Leave.buildFromGraphQL(leave))

    return new Leaves(leaveObjects)
  }

  get leavesLength(): number {
    return this.leaves.length
  }

  get leaveTypes(): string[] {
    return uniq(this.leaves.map((leave) => leave.typeName))
  }

  get _groupByType(): Record<string, Leave[]> {
    return groupBy(this.leaves, 'typeName')
  }

  filterByDate(date: moment.Moment): Leave[] {
    return this.leaves.filter((leave) => leave.isDuring(date))
  }

  filterByDateApproved(date: moment.Moment): Leave[] {
    return this.leaves.filter((leave) => leave.isDuring(date) && leave.approved)
  }

  filterByType(type: string): Leave[] {
    return this._groupByType[type] || []
  }
}

export default Leaves
